import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Row, Col, Card } from "react-bootstrap";
import { FaSearch, FaDownload, FaTimes } from "react-icons/fa";
import { getApiCall } from "../../service/httpCall";
import Loader from "../../components/partials/components/loader";
import { toast } from "react-toastify";
import { FilterMatchMode } from "primereact/api";
import { API_DASHBOARD_TODAY_RUNNING_CAMPAIGN_SUMMARY_STATS } from "../../service/url";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { USER_ROLES } from "../../utilities/constant";

const TodayRunningCampaigns = () => {
  const dt = useRef(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [tableFilters, setTableFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    campaignName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    campaignId: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);

  useEffect(() => {
    async function checkUserRole() {
      const rawUser = await AsyncStorage.getItem("user");
      if (!rawUser) {
        console.error("User not found in AsyncStorage");
        return null; // or handle as needed
      }
        
      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in user from AsyncStorage", e);
        return null;
      }
      if (user.role) {
        setLoggedInUserRole(user.role);
      }
    }
    checkUserRole();
  }, []);

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole == USER_ROLES.CALL_CENTRE_AGENT) {
      return;
    }
    fetchData();
  }, [loggedInUserRole]);

  const fetchData = () => {
    setLoading(true);

    getApiCall(API_DASHBOARD_TODAY_RUNNING_CAMPAIGN_SUMMARY_STATS)
      .then((resp) => {
        const formatted = (resp.data || resp).map((item) => ({
          ...item,
          campaignId: item.campaignId?.toString(),
          campaignName: item.campaignName?.toString(),
        }));

        setData(formatted);
      })
      .catch((err) => toast.error(err?.message || "Failed to fetch data"))
      .finally(() => setLoading(false));
  };

  const clearFilters = () => {
    setTableFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      campaignName: { value: null, matchMode: FilterMatchMode.CONTAINS },
      campaignId: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    setGlobalFilterValue("");
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setGlobalFilterValue(value);

    setTableFilters((prev) => ({
      ...prev,
      global: { value, matchMode: FilterMatchMode.CONTAINS },
    }));
  };

  const exportCSV = () => {
    const headers = [
      "Campaign ID",
      "Campaign Name",
      "Start Time",
      "Total Numbers",
      "Calls Dialed",
      "Pending Calls",
      "Connected Calls",
      "DTMF Count",
    ];

    const rows = data.map((row) => [
      row.campaignId,
      row.campaignName,
      row.startTime,
      row.totalNumbers,
      row.callsDialed,
      row.pendingCalls,
      row.connectedCalls,
      row.dtmfCount,
    ]);

    let csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "today-running-campaigns.csv";
    link.click();
  };

  if (loading) return <Loader />;

  return (
    <Card
      className="shadow-sm"
      style={{ marginTop: "40px", width: "100%" }}
    >
      <Card.Header>
        <h5>Today Running Campaigns</h5>
      </Card.Header>

      <Card.Body>
        {/* Top Controls */}
        <Row className="mb-3">
          <Col md={6}>
            <InputText
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              placeholder="Search by Campaign Name or ID..."
              className="w-100"
            />
          </Col>

          <Col md={6} className="d-flex justify-content-end gap-2">
            {/* <Button onClick={fetchData} className="bg-primary border-0">
              <FaSearch />
            </Button>

            <Button onClick={clearFilters} className="bg-secondary border-0">
              <FaTimes />
            </Button> */}

            {data?.length > 0 &&
            <Button onClick={exportCSV} className="bg-success border-0">
              <FaDownload />
            </Button>
            }
          </Col>
        </Row>

        {/* DataTable */}
        <div style={{ overflowX: "auto" }}>
        <DataTable
          ref={dt}
          value={data}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          filters={tableFilters}
          onFilter={(e) => setTableFilters(e.filters)}
          globalFilterFields={["campaignName", "campaignId"]}
          emptyMessage="No running campaigns found for today"
          responsiveLayout="scroll"
        >
          <Column
            field="campaignId"
            header="Campaign ID"
            sortable
            filter
            filterPlaceholder="Search ID"
          />

          <Column
            field="campaignName"
            header="Campaign Name"
            sortable
            filter
            filterPlaceholder="Search Name"
          />

          <Column field="startTime" header="Start Time" sortable />

          <Column field="totalNumbers" header="Total Numbers" sortable />

          <Column field="callsDialed" header="Calls Dialed" sortable />

          <Column field="pendingCalls" header="Pending Calls" sortable />

          <Column field="connectedCalls" header="Connected Calls" sortable />

          <Column field="dtmfCount" header="DTMF Count" sortable />
        </DataTable>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TodayRunningCampaigns;
